export abstract class PartnerProfileStore {}
